// extracted by mini-css-extract-plugin
export default {"main":"AdminLayout_main__qmdo7","body":"AdminLayout_body__OGGC1","content":"AdminLayout_content__0djIc"};